import React from 'react';
import markerIcon from '../../../../assets/marker.svg';
import { Marker, Tooltip } from 'react-leaflet';
import { Icon } from 'leaflet';
import { Box, Typography } from '@mui/material';
import LeafletMap from '../../../../components/mapBox/LeafletMap';
import mapStyles from './RegionMap.style';
import RegionType from '../../../../types/RegionType';
import { formatCurr } from '../../../../hooks/useFormatCurrency';

interface Iprops {
    mapData: RegionType[],
}

function RegionMap(props: Iprops) {
    const { mapData } = props;
    const classes = mapStyles();
    const customIcon = new Icon({
        iconUrl: markerIcon,
        iconSize: [15, 20],
    });

    return (
        <Box className={classes.mapStyles}>
            <LeafletMap
                zoomLevel={1}
            >
                {mapData?.map((region) => {
                    if (!region.is_country && Number(region?.latitude) && Number(region?.longitude)) {
                        const lat = Number(region?.latitude);
                        const lang = Number(region?.longitude);
                        return (
                            <Marker
                                position={[lat, lang]}
                                icon={customIcon}
                                key={region?.country_id}
                            >
                                <Tooltip
                                    offset={[0, -20]}
                                    direction="top"
                                    className={classes.tooltipContainer}
                                >
                                    <div>
                                        <Typography variant="h6">{`${region?.region}, ${region?.country}`}</Typography>
                                        <Typography variant="h6">{`Projects: ${region?.project_count}`}</Typography>
                                        <Typography variant="h6">
                                            {`Total Cost: $${region.total_cost ? formatCurr(+region.total_cost.toFixed(0), 'en-US') : '0'}`}
                                        </Typography>
                                    </div>
                                </Tooltip>
                            </Marker>
                        );
                    }
                    return '';
                })}
            </LeafletMap>
        </Box>
    );
}

export default RegionMap;
